<button (click)="donate()"
        class="button"
        mat-button
        [matTooltip]="DonateButtonConfig.tooltip">
  {{ DonateButtonConfig.label }}
</button>
